import { Trans } from "@lingui/macro";
import Image from "next/image";
import React from "react";
import styled from "styled-components";
import Carousel from "~/components/Carousel/Carousel";
import { Stack } from "~/guidelines/Flex";
import { useIsMobileDevice } from "~/guidelines/Theme/mediaQueries";
import { heading2, heading5 } from "~/guidelines/Typography";
import LogoKpmg from "~/pages/investisseurs/_assets/our-partners/KPMG.svg";
import LogoCdcHabitat from "~/pages/investisseurs/_assets/our-partners/cdc-habitat.png";
import LogoEternam from "~/pages/investisseurs/_assets/our-partners/eternam.png";
import LogoFianciereSaintJames from "~/pages/investisseurs/_assets/our-partners/financiere-st-james.png";
import LogoGrandEst from "~/pages/investisseurs/_assets/our-partners/grand-est.png";

const Container = styled(Stack)`
  align-items: center;
  max-width: 1200px;
  margin: 80px auto;

  @media (max-width: 1200px) {
    margin: 32px 16px;
  }
`;

const PreTitle = styled.h5`
  ${heading5}
  margin-bottom: 0px;
  text-align: center;
`;

const Title = styled.h2`
  ${heading2}
  margin-bottom: ${({ theme }) => theme.spacing(8)};
  text-align: center;
`;

const LogoWrapper = styled.div`
  width: 256px;
  height: 236px;
  background-color: ${({ theme }) => theme.color.background.lightFirst};
  padding: 40px 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;

  @media (max-width: 1200px) {
    width: 100%;
  }
`;

const SwiperWrapper = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;

  swiper-slide {
    max-width: 256px; /* Corresponds to LogoWrapper base width */
  }
`;

const OurPartners = () => {
  const isMobile = useIsMobileDevice();

  const LOGOS = [
    LogoEternam,
    LogoFianciereSaintJames,
    LogoCdcHabitat,
    LogoKpmg,
    LogoGrandEst,
  ];

  return (
    <Container>
      <PreTitle>
        <Trans>Ours</Trans>
      </PreTitle>

      <Title>
        <Trans>Partners</Trans>
      </Title>

      <SwiperWrapper>
        <Carousel
          items={LOGOS}
          centered={isMobile ? true : false}
          group={isMobile ? 1 : 4}
        >
          {(Logo, idx) => (
            <LogoWrapper>
              <Image
                src={Logo}
                alt={`Logo partenaire ${idx + 1}`}
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  width: "auto",
                  height: "auto",
                  objectFit: "contain",
                }}
              />
            </LogoWrapper>
          )}
        </Carousel>
      </SwiperWrapper>
    </Container>
  );
};

export default OurPartners;
